// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_2v-1";
export var rateTableServiceLevelDropdown = "_2v-3";
export var rateTableTypeDropdown = "_2v-0";
export var rateTableValueModeDropdown = "_2v-2";